"use client";

import { cn } from "@/lib/utils";

import type { WidgetSize } from "@/types";

// Column spans on the FOUR-column desktop grid, matching the header strip's
// rhythm. Four (not three) because `md` is the common size: on a 3-column grid a
// pair of md cards can't share a row, so every row wasted a third of the width.
//
// Mobile is always a single column — this app is bottom-nav, mobile-first, and a
// half-width card there is unusable.
const SPANS: Record<WidgetSize, string> = {
  sm: "lg:col-span-1",
  md: "lg:col-span-2",
  lg: "lg:col-span-4",
};

export function DashboardGrid({ children }: { children: React.ReactNode }) {
  return (
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-4">{children}</div>
  );
}

export function DashboardGridItem({
  size,
  children,
}: {
  size: WidgetSize;
  children: React.ReactNode;
}) {
  // A size the client doesn't recognise falls back to md rather than losing the
  // card — same forward-compatibility rule as the renderer switch.
  return <div className={cn(SPANS[size] ?? SPANS.md)}>{children}</div>;
}
